import React, { useState } from 'react'
import DropZoneArea from '../../Containers/Campaigns/Page/Codes/components/Popups/CodeUploadPopups/DropZoneArea'
import { Box, Button } from '@material-ui/core'
import { downloadStringAsFile, parseCSV } from '../../Utils/Misc'
import { apiClient } from '../../Module/API/Client'
import { useDispatch } from 'react-redux'
import { escapeCsvString } from '../../shared/csv'
import { showReduxModal, hideReduxModal } from 'Reducers/UI/actions'
import GenericFlatButton from '../GenericFlatButton'

const styles = {
  buttonContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignSelf: 'center',
    margin: '30px 0',
  },
  title: { fontSize: 24, fontFamily: "'Proxima Nova', sans-serif" },
  desc: { fontFamily: "'Proxima Nova', sans-serif" },
  downloadButton: {
    textTransform: 'none',
    fontSize: 16,
    alignSelf: 'center',
    width: '100%',
    color: 'black',
    fontFamily: "'Proxima Nova', sans-serif",
  },
  dropzoneContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
  },
}

const ImportUsersModal = ({ cityId }) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [files, setFiles] = useState([])
  const dispatch = useDispatch()

  const downloadTemplate = () => {
    downloadStringAsFile(
      'firstName,lastName,phone\nJohn,Doe,2341232',
      'user_import_template.csv',
      'text/csv',
    )
  }

  const onFileUpload = async () => {
    try {
      setLoading(true)
      const parsedData = await parseCSV(files[0])

      const { data: rows } = parsedData

      const res = await apiClient.importUsers(rows, cityId)
      const result = await res.json()

      if (result.error) {
        dispatch(
          showReduxModal({
            title: 'Validation error',
            children: result.message,
            confirmLabel: `OK`,
            hideCancel: true,
          }),
        )
      }

      let content = 'id,name,phone,email,password,url'
      result.forEach(
        row =>
          (content +=
            '\n' +
            ['id', 'name', 'phone', 'email', 'password', 'url']
              .map(headerName => {
                let value = row[headerName]

                return typeof value === 'string'
                  ? escapeCsvString(value)
                  : value
              })
              .join(',')),
      )

      downloadStringAsFile(
        content,
        `uploaded_users_for_city_${cityId}.csv`,
        'text/csv',
      )
      dispatch(hideReduxModal())
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }
  return (
    <div>
      <Box
        display="flex"
        flexWrap="wrap"
        justifyContent="center"
        mt={3}
        mb={3}
        style={styles.title}
      >
        User import
      </Box>
      <div style={styles.dropzoneContainer}>
        <DropZoneArea
          onFileUpload={files => setFiles(files)}
          error={error}
          setError={setError}
        />
      </div>
      <Box
        display="flex"
        flexWrap="wrap"
        justifyContent="center"
        mt={3}
        mb={1}
        style={styles.desc}
      >
        Please, use template to provide correct data
      </Box>
      <Button
        color="primary"
        style={styles.downloadButton}
        onClick={downloadTemplate}
      >
        Download template
      </Button>
      <div style={styles.buttonContainer}>
        <GenericFlatButton
          type={'outline'}
          title={'Cancel'}
          onClick={() => {
            dispatch(hideReduxModal())
          }}
        />
        <GenericFlatButton
          type={'filled'}
          title={'Confirm'}
          loading={loading}
          disabled={!files[0]}
          onClick={async () => {
            await onFileUpload()
          }}
        />
      </div>
    </div>
  )
}

export default ImportUsersModal
